export default {"src":"/_next/static/media/link.3e38710e.svg","height":513,"width":513};